import { downloadFromBlobUrl } from "../../../../../common/utils/download_utils";
import { IDownloadMateriaisControladosByIdUseCase } from "../../../presentation/useCases/read/download_materiais_controlados_by_id_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DownloadMateriaisControladosByIdUseCase
 */

export class DownloadMateriaisControladosByIdUseCase implements IDownloadMateriaisControladosByIdUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async downloadMateriaisControladosById(
    idMateriaisControlados: number,
    nomeArquivo: string,
  ): Promise<void> {
    const result = await this.repository.downloadMateriaisControladosById(idMateriaisControlados);
    await downloadFromBlobUrl(result, nomeArquivo);
  }
}
